<template>
  <div
    ref="pdfViewerContainerRef"
    class="max-h-viewer sticky top-8 h-full w-full"
  >
    <div class="flex items-center justify-between pb-2">
      <p class="text-xs text-gray-500">
        {{ activeCertPage?.filename }}
      </p>
      <div class="flex flex-row items-center">
        <label class="mr-2 text-xs text-gray-500">
          <span v-if="certPages?.length > 0">
            Attachment {{ selectedPage }} of {{ certPages?.length }}
          </span>
          <span
            v-else
            :class="{ 'text-transparent': !hasAttachments && rateConLink }"
          >
            No Attachments
          </span>
        </label>
      </div>
    </div>

    <div class="max-h-viewer relative h-full w-full overflow-scroll shadow-md">
      <div class="absolute inset-0 overflow-hidden">
        <!-- <div
          v-show="certPages?.length > 0"
          class="absolute right-4 top-4 z-40 h-10 w-auto"
        >
          <div
            class="rounded-md border-yellow-500 bg-yellow-500 text-white hover:border-yellow-600 hover:bg-yellow-600"
          >
            <button
              class="flex h-full w-full cursor-pointer gap-1.5 px-6 py-3"
              @click="downloadAttachment()"
            >
              <span class="text-base">Download</span>
              <svg
                class="h-6 w-6"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 14.3906L11.2929 15.0977L12 15.8048L12.7071 15.0977L12 14.3906ZM7.29289 11.0977L11.2929 15.0977L12.7071 13.6835L8.70711 9.68352L7.29289 11.0977ZM12.7071 15.0977L16.7071 11.0977L15.2929 9.68352L11.2929 13.6835L12.7071 15.0977Z"
                  fill="currentColor"
                />
                <path
                  d="M12 14.3906L12 4.39063"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <path
                  d="M5 9.39062V18.3906H19V9.39062"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
        </div> -->
        <div
          v-show="totalPages > 1"
          class="absolute bottom-4 left-4 z-40 h-10 w-auto"
        >
          <div
            class="divide-x-1 grid grid-cols-2 divide-placeholder-gray rounded-md border-placeholder-gray"
          >
            <button
              class="col-span-1 w-full cursor-pointer rounded-l-md border border-r-2 border-placeholder-gray px-3 py-2"
              :class="
                activeCertPageIndex == 0
                  ? 'bg-gray-over-dark'
                  : 'bg-dark-blue hover:bg-dark-gray'
              "
              @click="updateActivePage(-1)"
            >
              <svg
                class="mx-auto h-6 w-auto cursor-pointer"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 1L2 7L8 13"
                  stroke="#C7CBDB"
                  stroke-width="2"
                />
              </svg>
            </button>
            <button
              class="col-span-1 w-full cursor-pointer rounded-r-md border border-l-2 border-placeholder-gray px-3 py-2"
              :class="
                totalPages - 1 == activeCertPageIndex
                  ? 'bg-gray-over-dark'
                  : 'bg-dark-blue hover:bg-dark-gray'
              "
              @click="updateActivePage(1)"
            >
              <svg
                class="mx-auto h-6 w-auto cursor-pointer"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L7 7L0.999999 13"
                  stroke="#C7CBDB"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          class="absolute bottom-4 right-4 z-40 flex h-64 w-12 flex-col items-center justify-end gap-3"
        >
          <!-- <div class="grid grid-rows-1 rounded-md border-placeholder-gray divide-placeholder-gray w-full">
            <button @click="toggleShowBoundingBoxes()" class="row-span-1 cursor-pointer bg-dark-blue hover:bg-dark-gray rounded-md p-1 w-full border border-placeholder-gray flex justify-center items-center">
              <svg v-if="showBoundingBoxes" class="h-10 w-auto" viewBox="0 0 22 29.81">
                <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g class="cls-bb1-1"><path class="cls-bb1-2" d="M19,24.75H3a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2H19a2,2,0,0,1,2,2v16A2,2,0,0,1,19,24.75Z"/><path class="cls-bb1-2" d="M19,25.75H3a3,3,0,0,1-3-3v-16a3,3,0,0,1,3-3H19a3,3,0,0,1,3,3v16A3,3,0,0,1,19,25.75ZM3,5.75a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z"/></g><path class="cls-bb1-2" d="M19,25.75H3a3,3,0,0,1-3-3v-16a3,3,0,0,1,3-3H19a3,3,0,0,1,3,3v16A3,3,0,0,1,19,25.75ZM3,5.75a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z"/><line class="cls-bb1-3" x1="18" y1="1" x2="2.69" y2="28.81"/></g></g>
              </svg>
              <svg v-if="!showBoundingBoxes" class="h-10 w-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.97 29.81">
                <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><line class="cls-bb2-1" x1="17.45" y1="1" x2="2.14" y2="28.81"/><g class="cls-bb2-2"><path class="cls-bb2-3" d="M20,22.75v-16a1,1,0,0,0-1-1H17.4l-9.91,18H19A1,1,0,0,0,20,22.75Z"/><polygon class="cls-bb2-4" points="18.51 3.75 18.46 3.75 17.91 4.75 17.95 4.75 18.51 3.75"/><polygon class="cls-bb2-4" points="6.9 24.75 6.35 25.75 6.39 25.75 6.94 24.75 6.9 24.75"/><path class="cls-bb2-4" d="M19,3.75h-.46l-.55,1h1a2,2,0,0,1,2,2v16a2,2,0,0,1-2,2h-12l-.55,1H19a3,3,0,0,0,3-3v-16A3,3,0,0,0,19,3.75Z"/><path class="cls-bb2-4" d="M19,5.75a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1H7.49l-.55,1H19a2,2,0,0,0,2-2v-16a2,2,0,0,0-2-2H18l-.56,1Z"/><polygon class="cls-bb2-4" points="17.95 4.75 17.91 4.75 17.36 5.75 17.4 5.75 17.95 4.75"/><polygon class="cls-bb2-4" points="7.49 23.75 7.45 23.75 6.9 24.75 6.94 24.75 7.49 23.75"/></g><g class="cls-bb2-2"><path class="cls-bb2-3" d="M2,6.9v16a1,1,0,0,0,.43.8L12.24,5.9H3A1,1,0,0,0,2,6.9Z"/><path class="cls-bb2-4" d="M1,22.9V6.9a2,2,0,0,1,2-2h9.79l.55-1H3a3,3,0,0,0-3,3v16a3,3,0,0,0,1.47,2.55l.47-.86A2,2,0,0,1,1,22.9Z"/><path class="cls-bb2-4" d="M1,6.9v16a2,2,0,0,0,.94,1.69l.49-.89A1,1,0,0,1,2,22.9V6.9a1,1,0,0,1,1-1h9.24l.55-1H3A2,2,0,0,0,1,6.9Z"/></g></g></g>
              </svg>
            </button>
          </div> -->
          <!-- <div class="grid grid-rows-1 rounded-md border-placeholder-gray divide-placeholder-gray">
            <button @click="scaleReset()" class="row-span-1 cursor-pointer bg-dark-blue hover:bg-dark-gray rounded-md p-1 w-full border border-placeholder-gray">
              <svg class="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="6" stroke="#C7CBDB" stroke-width="2"/>
                <rect x="11" y="3" width="2" height="5" fill="#C7CBDB"/>
                <rect x="11" y="16" width="2" height="5" fill="#C7CBDB"/>
                <rect x="21" y="11" width="2" height="5" transform="rotate(90 21 11)" fill="#C7CBDB"/>
                <rect x="8" y="11" width="2" height="5" transform="rotate(90 8 11)" fill="#C7CBDB"/>
                <circle cx="12" cy="12" r="2" fill="#C7CBDB"/>
              </svg>
            </button>
          </div> -->
          <div
            v-if="hasAttachments"
            class="grid grid-rows-2 divide-y-2 divide-placeholder-gray rounded-md border-placeholder-gray"
          >
            <button
              class="row-span-1 w-full cursor-pointer rounded-t-md border border-placeholder-gray bg-dark-blue p-2 pb-0 hover:bg-dark-gray"
              @click="scaleUp"
            >
              <svg
                class="relative bottom-1 h-8 w-8"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="scaleUp"
              >
                <path
                  d="M11 19L11 3"
                  stroke="#C7CBDB"
                  stroke-width="3"
                />
                <path
                  d="M19 11L3 11"
                  stroke="#C7CBDB"
                  stroke-width="3"
                />
              </svg>
            </button>
            <button
              class="row-span-1 w-full cursor-pointer rounded-b-md border border-placeholder-gray bg-dark-blue p-2 pt-0 hover:bg-dark-gray"
              @click="scaleDown"
            >
              <svg
                class="relative top-1 h-10 w-8 cursor-pointer hover:opacity-80"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="scaleDown"
              >
                <!-- <path d="M11 19L11 3" stroke="#C7CBDB" stroke-width="3"/> -->
                <path
                  d="M19 11L3 11"
                  stroke="#C7CBDB"
                  stroke-width="3"
                />
              </svg>
            </button>
          </div>
          <div
            v-if="hasAttachments"
            class="grid grid-rows-1 divide-placeholder-gray rounded-md border-placeholder-gray"
          >
            <button
              class="row-span-1 w-full cursor-pointer rounded-md border border-placeholder-gray bg-dark-blue p-0 hover:bg-dark-gray"
              @click="scaleFull()"
            >
              <svg
                class="h-12 w-12"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="31"
                  height="31"
                  rx="4.5"
                />
                <path
                  d="M25.7776 6.12132L19.1207 12.7782M25.7776 6.12132V10.364M25.7776 6.12132H21.5349"
                  stroke="#C7CBDB"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M6.12087 6.12132L12.7777 12.7782M6.12087 6.12132V10.364M6.12087 6.12132H10.3635"
                  stroke="#C7CBDB"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M5.87868 25.8787L12.5355 19.2218M5.87868 25.8787V21.636M5.87868 25.8787H10.1213"
                  stroke="#C7CBDB"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M26.1213 25.8787L19.4645 19.2218M26.1213 25.8787V21.636M26.1213 25.8787H21.8787"
                  stroke="#C7CBDB"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="31"
                  height="31"
                  rx="4.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div
        id="viewer"
        class="relative h-full max-h-full w-full overflow-auto rounded-md border-2 border-dark-gray"
        :class="
          !hasAttachments && rateConLink ? 'bg-steel-100' : 'pdf-backdrop-color'
        "
      >
        <div
          v-if="!hasAttachments && rateConLink"
          class="flex h-full w-full flex-col items-center justify-center gap-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="46"
            viewBox="0 0 40 46"
            fill="none"
          >
            <path
              d="M21.75 33.5C22.7165 33.5 23.5 34.2835 23.5 35.25C23.5 36.2165 22.7165 37 21.75 37H11.25C10.2835 37 9.5 36.2165 9.5 35.25C9.5 34.2835 10.2835 33.5 11.25 33.5H21.75Z"
              fill="#6C7C9D"
            />
            <path
              d="M21.75 26.5C22.7165 26.5 23.5 27.2835 23.5 28.25C23.5 29.2165 22.7165 30 21.75 30H11.25C10.2835 30 9.5 29.2165 9.5 28.25C9.5 27.2835 10.2835 26.5 11.25 26.5H21.75Z"
              fill="#6C7C9D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.9223 0.258203C29.323 0.297911 29.7001 0.475445 29.9873 0.762695L38.7373 9.5127C39.0655 9.84088 39.25 10.2859 39.25 10.75V35.25C39.25 36.1783 38.881 37.0682 38.2246 37.7246C37.5682 38.381 36.6783 38.75 35.75 38.75H32.25V42.25C32.25 43.1783 31.881 44.0682 31.2246 44.7246C30.5682 45.381 29.6783 45.75 28.75 45.75H4.25C3.32175 45.75 2.43177 45.381 1.77539 44.7246C1.11901 44.0682 0.75 43.1783 0.75 42.25V10.75C0.75 9.82174 1.11901 8.93177 1.77539 8.27539C2.43177 7.61901 3.32174 7.25 4.25 7.25H7.75V3.75C7.75 2.82174 8.11901 1.93177 8.77539 1.27539C9.43177 0.619014 10.3217 0.25 11.25 0.25H28.75L28.9223 0.258203ZM4.25 42.25H28.75V18.4746L21.0254 10.75H4.25V42.25ZM11.25 7.25H21.75L21.9223 7.2582C22.323 7.29791 22.7001 7.47544 22.9873 7.7627L31.7373 16.5127C32.0655 16.8409 32.25 17.2859 32.25 17.75V35.25H35.75V11.4746L28.0254 3.75H11.25V7.25Z"
              fill="#6C7C9D"
            />
          </svg>
          <a
            :href="rateConLink"
            target="_blank"
            class="custom-button primary-button flex h-11 w-fit items-center justify-center gap-4 rounded-[5px] border-t-[0.50px]"
          >
            View Secure Rate Confirmation
          </a>
        </div>
        <div
          v-show="isCertificateViewerLoaded"
          id="certificate_wrap_page1"
          class="relative origin-top-left"
          :class="{ 'page-transition': pageTransition }"
          :style="'transform: scale(' + scale + ');'"
        >
          <!-- <img id="certificate_page1" class="object-cover" :src="'data:' + imageContentType + ';base64,' + imageBase64" :style="testingCss"> -->
          <!-- <img v-show="imageUrl" id="certificate_page1" class="object-cover" :src="testingMode ? certificateUrl : imageUrl" :style="testingCss"> -->
          <!-- <div class="absolute inset-0">
            <div 
              v-if="showBoundingBoxes"
              class="absolute border-4 border-yellow-500 bg-yellow-20 bg-opacity-30 z-50"
              :style="boxStyle"
            ></div>
          </div> -->
        </div>
        <div
          v-for="(page, index) in certPages"
          v-show="isCertificateViewerLoaded && index === activeCertPageIndex"
          id="certificate_wrap_page1"
          :key="`cert-page-index-${index}`"
          class="relative h-full w-full origin-top-left"
          :style="'transform: scale(' + scale + ');'"
        >
          <!-- <img 
            v-show="page?.url" 
            id="certificate_page1" 
            class="object-cover" 
            :src="page?.url" 
            :style="testingCss"
            @load="onImageLoad"
          >  -->
          <iframe
            v-show="page?.url"
            id="certificate_page1"
            class="h-full w-full border-0 object-cover"
            style="
              background: #ffffff !important;
              background-color: #ffffff !important;
            "
            :src="`${page?.url}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0&theme_mode=dark`"
            allowtransparency="true"
            frameborder="0"
            @load="onImageLoad"
          />
        </div>
        <div
          v-show="!isCertificateViewerLoaded"
          class="absolute inset-0"
        >
          <div
            class="flex h-full w-full items-center justify-center bg-dark-gray bg-opacity-70"
          >
            <div
              class="flex h-20 items-center justify-center gap-3 rounded-md bg-white px-8 shadow-xl"
            >
              <div class="text-body-color">Loading PDF</div>
              <svg
                class="loading h-8 w-8"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
                  stroke="#F8C617"
                  stroke-width="3"
                />
                <path
                  d="M16 1V7L20 4L16 1Z"
                  fill="#F8C617"
                />
                <path
                  d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
                  stroke="#F8C617"
                  stroke-width="3"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="certPages?.length > 1"
      class="flex justify-center py-4"
    >
      <pagination-v2
        :selected-page="selectedPage"
        :total-pages="totalPages"
        @select-page="onSelectPage"
      />
    </div>
  </div>
</template>

<script>
// import testSecondCertPage from '@/common/testSecondCertPage';
import PaginationV2 from '@/components/PaginationV2.vue';

export default {
  name: 'PdfViewer',
  components: {
    PaginationV2,
  },
  props: {
    formPosition: Number,
    stepTypes: Array,
    data: Object,
    stepName: String,
    textract: Object,
    image: Object,
    rateConLink: String,
  },
  data() {
    return {
      testingMode: false,
      loaded: false,
      pageTransition: false,
      activeCertPageIndex: 0,
      activeCertPage: null,
      testMultiplePages: false,
      testingMultipleCertPages: [],
      showBoundingBoxes: false,
      textractData: null,
      currentStep: 0,
      // certificateUrl: null,
      certificateUrl: '/src/common/sampleCertificate.jpg',
      certImage: null,
      certData: null,
      testingCss: null, //'transform: scale(0.941) translateY(-16.5px);',
      // testingCss: 'transform: scale(0.941) translateY(-16.5px);',
      boundingBox: {
        topLeft: {
          x: null,
          y: null,
        },
        topRight: {
          x: null,
          y: null,
        },
        bottomLeft: {
          x: null,
          y: null,
        },
        bottomRight: {
          x: null,
          y: null,
        },
      },
      boundingBoxDimensions: {
        width: null,
        height: null,
      },
      showBoundingBox: false,
      scale: null,
      defaultScale: null,
      scaleStepPct: 10,
      scaleMax: {
        x: 3,
        y: 10,
      },
      scrollParams: {
        offset: {
          top: 133,
          left: 60,
          buffer: 10,
        },
        page1: {
          top: null,
          left: null,
        },
      },
      scrollMargin: {
        x: 0.1,
        y: 0.1,
        default: {
          x: null,
          y: null,
        },
      },
      viewer: null,
      viewerDimensions: {
        width: null,
        height: null,
        center: {
          x: null,
          y: null,
        },
      },
      viewerBoundingRect: {
        top: null,
        right: null,
        bottom: null,
        left: null,
      },
      page1BoundingRect: {
        top: null,
        right: null,
        bottom: null,
        left: null,
      },
      page1Dimensions: {
        width: null,
        height: null,
        center: {
          x: null,
          y: null,
        },
      },
      zoomBasedOn: null,
      controlClick: false,
      unwatch: null,
      complex: null,
      certPages: null,
      certPagesIndex: 0,
      // imageContentType: null,
      imageUrl: null,
    };
  },
  computed: {
    boxStyle() {
      return {
        left: this.boundingBox.topLeft.x * 100 + '%',
        right: (1 - this.boundingBox.topRight.x) * 100 + '%',
        top: this.boundingBox.topLeft.y * 100 + '%',
        bottom: this.boundingBox.bottomRight.y * 100 + '%',
        // width: ((this.boundingBox.topRight.x - this.boundingBox.topLeft.x) * 100) + '%',
        // height: ((this.boundingBox.topLeft.y - this.boundingBox.bottomRight.y) * 100) + '%',
      };
      // return {
      // left: (this.boundingBox.topLeft.x * 100) + '%',
      // right: ((1-this.boundingBox.topRight.x) * 100) + '%',
      // top: (this.boundingBox.topLeft.y * 100) + '%',
      // bottom: ((1-this.boundingBox.bottomRight.y) * 100) + '%',
      // }
    },
    totalPages() {
      if (this.testMultiplePages == true) {
        return this.testingMultipleCertPages.length;
      } else {
        return this.certPages?.length;
      }
    },
    selectedPage() {
      return this.activeCertPageIndex + 1;
    },
    // setCertImage() {
    //   // var self = this;
    //   let returnVal = 'unset'
    //   if (this.$store.state.form.checkoutCertificate) {
    //     if (this.$store.state.form.checkoutCertificate.certificate_pages) {
    //       this.$store.state.form.checkoutCertificate?.certificate_pages?.forEach(function(page, index) {
    //         // first page only for now
    //         if (index == 0) {

    //           // self.certImage = { ...page.data };
    //           let firstpage = { ...page.data };
    //           console.log('firstpage = ');
    //           console.dir(firstpage);
    //           return firstpage;
    //         }
    //       });
    //     } else {
    //       return 'unset';
    //     }
    //   } else {
    //     return 'unset';
    //   }
    // },
    setCertImage2() {
      // return this.$store.state.form.checkoutCertificate;
      return null;
    },
    setCertPages() {
      return this.$store.state.rates.current_rate?.attachments;
    },
    hasAttachments() {
      return this.$store.state.rates.current_rate?.attachments?.length > 0;
    },
    isCertificateViewerLoaded() {
      // return this.$store.state.form.certificate_viewer_loaded;
      return true;
    },
  },
  // emits: ["showModalOverlay"],
  watch: {
    viewerBoundingRect(newVal) {
      if (!newVal) {
        return;
      }
      this.viewerDimensions.center.x =
        (newVal.right - newVal.left) / 2 + newVal.left;
      this.viewerDimensions.center.y =
        (newVal.bottom - newVal.top) / 2 + newVal.top;
      this.viewerDimensions.width = newVal.width;
      this.viewerDimensions.height = newVal.height;
      this.scrollMargin.default.x =
        this.scrollParams.offset.left / newVal.width;
      this.scrollMargin.default.y =
        this.scrollParams.offset.top / newVal.height;
    },
    page1BoundingRect(newVal) {
      if (!newVal) {
        return;
      }
      console.log('page1boundingrect');
      console.dir(newVal);
      this.page1Dimensions.width = newVal.width;
      this.page1Dimensions.height = newVal.height;
      this.page1Dimensions.center.x =
        (newVal.right - newVal.left) / 2 + newVal.left;
      this.page1Dimensions.center.y =
        (newVal.bottom - newVal.top) / 2 + newVal.top;
      this.setScrollParams();
    },
    scale(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setPage1BoundingRect();
      }
    },
    controlClick(newVal) {
      if (newVal == true) {
        var self = this;
        setTimeout(function () {
          self.controlClick = false;
        }, 500);
      }
    },
    setCertImage2: {
      deep: true,
      handler: function (newVal) {
        this.certData = newVal;
        console.log('setCertImage2 watch triggered');
        // this.certData = this.setCertImage2;
      },
      immediate: true,
    },
    setCertPages: {
      deep: true,
      handler: function (newVal) {
        var self = this;
        this.certPages = newVal;
        if (Array.isArray(this.certPages)) {
          console.log('setCertPages is ARRAY');
          this.certPages.forEach(function (item, index) {
            // first page only for now
            // TODO - add multiple pages, v-for and hide all index > 0 until tabbed with < > arrows in bottom left of viewer
            if (index == 0) {
              // self.imageContentType = item.image.content_type;
              self.certificateUrl = item?.url;
              self.imageUrl = item?.url;
              self.activeCertPage = item;
              self.loaded = true;
            }
          });
          // if (this.testMultiplePages == true) {
          //   // this.certPages.push(testPage2);
          //   this.testingMultipleCertPages.push(this.certPages[0]);
          //   let tempPage = {
          //     image: {
          //       content_type: 'image/png',
          //       data: null
          //     }
          //   };
          //   tempPage.image.data = testSecondCertPage.img_data;
          //   this.testingMultipleCertPages.push(tempPage);
          //   let tempPage2 = {
          //     image: {
          //       content_type: 'image/png',
          //       data: this.certPages[0].image.data
          //     }
          //   };
          //   tempPage.image.data = testSecondCertPage.img_data;
          //   this.testingMultipleCertPages.push(tempPage2);
          //   this.testingMultipleCertPages.push(tempPage);
          // }
        } else {
          console.log('setCertPages is NOT array');
        }

        console.log('setCertPages watch triggered');
        // this.certData = this.setCertImage2;
      },
      immediate: true,
    },
    certPagesIndex(newVal) {
      let self = this;
      if (Array.isArray(this.certPages)) {
        this.certPages.forEach(function (item, index) {
          // first page only for now
          // TODO - add multiple pages, v-for and hide all index > 0 until tabbed with < > arrows in bottom left of viewer
          if (index == newVal) {
            // self.imageContentType = item.image.content_type;
            self.certificateUrl = item?.url;
            self.imageUrl = item?.url;
            self.activeCertPage = item;
            self.loaded = true;
          }
        });
      }
    },
    loaded(newVal) {
      if (newVal == true) {
        this.$store.commit('form/setCertificateViewerLoaded', true);
      } else {
        this.$store.commit('form/setCertificateViewerLoaded', false);
      }
    },
    activeCertPageIndex(newVal) {
      this.loaded = false;
      this.pageTransition = true;
      if (this.testMultiplePages == true) {
        this.activeCertPage = this.testingMultipleCertPages[newVal];
      } else {
        this.activeCertPage = this.certPages?.[newVal];
      }
      this.imageContentType = this.activeCertPage?.content_type;
      this.imageBase64 = this.activeCertPage?.data;
      this.imageUrl = this.activeCertPage?.url;
      this.loaded = true;
    },
    pageTransition(newVal) {
      var self = this;
      if (newVal == true) {
        setTimeout(function () {
          self.pageTransition = false;
        }, 200);
      }
    },
  },
  created() {
    // this.unwatch = this.$store.watch(
    //   (state) => state.checkoutCertificate,
    //   (newValue, oldValue) => {
    //     console.log(`Updating from ${oldValue} to ${newValue}`);
    //     // Do whatever makes sense now
    //     if (newValue) {
    //       this.certData = newValue;
    //       this.complex = {
    //         deep: 'some deep object',
    //       };
    //     }
    //   },
    // );
  },
  mounted() {
    // this.certificateUrl = this.image;
    // this.setCertImage();
    this.setTextract();
    this.setViewer();
    this.setViewerBoundingRect();
    // this.setPage1BoundingRect();
    this.setUpDrag();
    if (this.$refs.pdfViewerContainerRef) {
      this.$refs.pdfViewerContainerRef.addEventListener(
        'contextmenu',
        (event) => {
          event.preventDefault();
        }
      );
    }
  },
  beforeUpdate() {
    if (this.controlClick == false) {
      this.showBoundingBox = false;
      // this.setBoundingBox();
    }
  },
  methods: {
    async downloadAttachment() {
      const response = await this.$store.dispatch(
        'rates/downloadRateAttachment',
        { id: this.$route?.params?.id, attachment_index: this.certPagesIndex }
      );
      if (response?.data) {
        const blob = new Blob([response.data]);
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition.match(/filename\*=UTF-8''(.+)/)[1];
        const decodedFilename = decodeURIComponent(filename);
        // IE doesn't support download attribute on anchor tags, so check if browser is IE or not
        if (window?.navigator && window?.navigator?.msSaveOrOpenBlob) {
          // If IE, use proprietary msSaveOrOpenBlob method
          window?.navigator?.msSaveOrOpenBlob(blob, decodedFilename);
        } else {
          // If not IE, create a temporary link element, simulate click, then remove
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', decodedFilename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      }
    },
    onSelectPage(page) {
      this.certPagesIndex = page - 1;
      this.activeCertPageIndex = page - 1;
    },
    onImageLoad() {
      this.setViewerBoundingRect();
      this.setPage1BoundingRect();
      this.setBoundingBox();
      this.scaleFull();
    },
    setTextract() {
      // var self = this;
      // this.$store.state.form.checkoutCertificate?.insurance_certificate_pages?.forEach(function(page, index) {
      //   // first page only for now
      //   if (index == 0) {
      //     self.textractData = { ...page.textract_form };
      //   }
      // });
    },
    // setCertImage() {
    //   var self = this;
    //   this.$store.state.form.checkoutCertificate?.certificate_pages?.forEach(function(page, index) {
    //     // first page only for now
    //     if (index == 0) {

    //       // self.certImage = { ...page.data };
    //       return { ...page.data };
    //     }
    //   });
    // },
    toggleShowBoundingBoxes() {
      var self = this;
      this.controlClick = true;
      this.showBoundingBoxes = !this.showBoundingBoxes;
      setTimeout(function () {
        self.controlClick = false;
      }, 500);
    },
    scaleUp() {
      var self = this;
      this.controlClick = true;
      this.scale = this.scale + this.scale * (this.scaleStepPct / 100);
      setTimeout(function () {
        self.controlClick = false;
      }, 500);
    },
    scaleDown() {
      var self = this;
      this.controlClick = true;
      this.scale = this.scale - this.scale * (this.scaleStepPct / 100);
      setTimeout(function () {
        self.controlClick = false;
      }, 500);
    },
    scaleReset() {
      // var self = this;
      this.controlClick = false;
      this.showBoundingBox = false;
      this.setBoundingBox();
      // setTimeout(function() {
      //   self.controlClick = false;
      // },500);
    },
    scaleFull() {
      var self = this;
      this.controlClick = true;
      this.scale = 1;
      let viewer = document.getElementById('viewer');
      setTimeout(function () {
        self.scrollToTop(viewer);
      }, 50);
      setTimeout(function () {
        self.controlClick = false;
      }, 500);
    },
    scrollToTop(el) {
      if (!el) {
        return;
      }
      el.scrollTop = 0;
      el.scrollLeft = 0;
    },
    setUpDrag() {
      const ele = document.getElementById('viewer');
      ele.style.cursor = 'grab';

      let pos = { top: 0, left: 0, x: 0, y: 0 };

      const mouseDownHandler = function (e) {
        ele.style.cursor = 'grabbing';
        ele.style.userSelect = 'none';

        pos = {
          left: ele.scrollLeft,
          top: ele.scrollTop,
          // Get the current mouse position
          x: e.clientX,
          y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
      };

      const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        ele.scrollTop = pos.top - dy;
        ele.scrollLeft = pos.left - dx;
      };

      const mouseUpHandler = function () {
        ele.style.cursor = 'grab';
        ele.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      // Attach the handler
      ele.addEventListener('mousedown', mouseDownHandler);
    },
    setBoundingBox() {
      switch (this.stepName) {
        case 'Insured':
          // this.boundingBox.topLeft.x = 0.09464816749095917;
          // this.boundingBox.topLeft.y = 0.23864807188510895;
          // this.boundingBox.topRight.x = 0.499;
          // this.boundingBox.topRight.y = 0.23864807188510895;
          // this.boundingBox.bottomLeft.x = 0.09464816749095917;
          // this.boundingBox.bottomLeft.y = 0.304;
          // this.boundingBox.bottomRight.x = 0.499;
          // this.boundingBox.bottomRight.y = 0.304;

          // this.boundingBox.topLeft.x = 0.0565;
          // this.boundingBox.topLeft.y = 0.232;
          // this.boundingBox.topRight.x = 0.499;
          // this.boundingBox.topRight.y = 0.232;
          // this.boundingBox.bottomLeft.x = 0.0565;
          // this.boundingBox.bottomLeft.y = 0.304;
          // this.boundingBox.bottomRight.x = 0.499;
          // this.boundingBox.bottomRight.y = 0.304;

          this.boundingBox.topLeft.x =
            this.certPages[0]?.textract_form?.carrier?.name_ocr?.box?.left;
          this.boundingBox.topLeft.y =
            this.certPages[0]?.textract_form?.carrier?.name_ocr?.box?.top;
          this.boundingBox.topRight.x =
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.left +
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.width +
            this.certPages[0]?.textract_form?.carrier?.state_ocr?.box?.width +
            this.certPages[0]?.textract_form?.carrier?.postal_code_ocr?.box
              ?.width;
          this.boundingBox.topRight.y =
            this.certPages[0]?.textract_form?.carrier?.name_ocr?.box?.top;
          this.boundingBox.bottomLeft.x =
            this.certPages[0]?.textract_form?.carrier?.name_ocr?.box?.left;
          this.boundingBox.bottomLeft.y =
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.top -
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.height;
          this.boundingBox.bottomRight.x =
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.left +
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.width +
            this.certPages[0]?.textract_form?.carrier?.state_ocr?.box?.width +
            this.certPages[0]?.textract_form?.carrier?.postal_code_ocr?.box
              ?.width;
          this.boundingBox.bottomRight.y =
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.top -
            this.certPages[0]?.textract_form?.carrier?.city_ocr?.box?.height;
          break;
        case 'Producer':
          this.boundingBox.topLeft.x = 0.0565;
          this.boundingBox.topLeft.y = 0.161;
          this.boundingBox.topRight.x = 0.499;
          this.boundingBox.topRight.y = 0.161;
          this.boundingBox.bottomLeft.x = 0.0565;
          this.boundingBox.bottomLeft.y = 0.234;
          this.boundingBox.bottomRight.x = 0.499;
          this.boundingBox.bottomRight.y = 0.234;
          break;
        case 'Insurer':
          this.boundingBox.topLeft.x = 0.497;
          this.boundingBox.topLeft.y = 0.216;
          this.boundingBox.topRight.x = 0.941;
          this.boundingBox.topRight.y = 0.216;
          this.boundingBox.bottomLeft.x = 0.497;
          this.boundingBox.bottomLeft.y = 0.235;
          this.boundingBox.bottomRight.x = 0.941;
          this.boundingBox.bottomRight.y = 0.235;
          break;
        case 'PolicyType':
          this.boundingBox.topLeft.x = 0.0565;
          this.boundingBox.topLeft.y = 0.471;
          this.boundingBox.topRight.x = 0.942;
          this.boundingBox.topRight.y = 0.471;
          this.boundingBox.bottomLeft.x = 0.0565;
          this.boundingBox.bottomLeft.y = 0.546;
          this.boundingBox.bottomRight.x = 0.942;
          this.boundingBox.bottomRight.y = 0.546;
          break;
        case 'PolicyNumber':
          this.boundingBox.topLeft.x = 0.352;
          this.boundingBox.topLeft.y = 0.471;
          this.boundingBox.topRight.x = 0.54;
          this.boundingBox.topRight.y = 0.471;
          this.boundingBox.bottomLeft.x = 0.352;
          this.boundingBox.bottomLeft.y = 0.546;
          this.boundingBox.bottomRight.x = 0.54;
          this.boundingBox.bottomRight.y = 0.546;
          break;
        case 'PolicyEffectiveDate':
          this.boundingBox.topLeft.x = 0.534;
          this.boundingBox.topLeft.y = 0.471;
          this.boundingBox.topRight.x = 0.611;
          this.boundingBox.topRight.y = 0.471;
          this.boundingBox.bottomLeft.x = 0.534;
          this.boundingBox.bottomLeft.y = 0.546;
          this.boundingBox.bottomRight.x = 0.611;
          this.boundingBox.bottomRight.y = 0.546;
          break;
        case 'PolicyExpirationDate':
          this.boundingBox.topLeft.x = 0.605;
          this.boundingBox.topLeft.y = 0.471;
          this.boundingBox.topRight.x = 0.683;
          this.boundingBox.topRight.y = 0.471;
          this.boundingBox.bottomLeft.x = 0.605;
          this.boundingBox.bottomLeft.y = 0.546;
          this.boundingBox.bottomRight.x = 0.683;
          this.boundingBox.bottomRight.y = 0.546;
          break;
        case 'PolicyLimit':
          this.boundingBox.topLeft.x = 0.677;
          this.boundingBox.topLeft.y = 0.471;
          this.boundingBox.topRight.x = 0.942;
          this.boundingBox.topRight.y = 0.471;
          this.boundingBox.bottomLeft.x = 0.677;
          this.boundingBox.bottomLeft.y = 0.49;
          this.boundingBox.bottomRight.x = 0.942;
          this.boundingBox.bottomRight.y = 0.49;
          break;
        case 'PolicyTypeTwo':
          this.boundingBox.topLeft.x = 0.0565;
          this.boundingBox.topLeft.y = 0.641;
          this.boundingBox.topRight.x = 0.942;
          this.boundingBox.topRight.y = 0.641;
          this.boundingBox.bottomLeft.x = 0.0565;
          this.boundingBox.bottomLeft.y = 0.688;
          this.boundingBox.bottomRight.x = 0.942;
          this.boundingBox.bottomRight.y = 0.688;
          break;
        case 'PolicyNumberTwo':
          this.boundingBox.topLeft.x = 0.352;
          this.boundingBox.topLeft.y = 0.641;
          this.boundingBox.topRight.x = 0.54;
          this.boundingBox.topRight.y = 0.641;
          this.boundingBox.bottomLeft.x = 0.352;
          this.boundingBox.bottomLeft.y = 0.688;
          this.boundingBox.bottomRight.x = 0.54;
          this.boundingBox.bottomRight.y = 0.688;
          break;
        case 'PolicyEffectiveDateTwo':
          this.boundingBox.topLeft.x = 0.534;
          this.boundingBox.topLeft.y = 0.641;
          this.boundingBox.topRight.x = 0.611;
          this.boundingBox.topRight.y = 0.641;
          this.boundingBox.bottomLeft.x = 0.534;
          this.boundingBox.bottomLeft.y = 0.688;
          this.boundingBox.bottomRight.x = 0.611;
          this.boundingBox.bottomRight.y = 0.688;
          break;
        case 'PolicyExpirationDateTwo':
          this.boundingBox.topLeft.x = 0.605;
          this.boundingBox.topLeft.y = 0.641;
          this.boundingBox.topRight.x = 0.683;
          this.boundingBox.topRight.y = 0.641;
          this.boundingBox.bottomLeft.x = 0.605;
          this.boundingBox.bottomLeft.y = 0.688;
          this.boundingBox.bottomRight.x = 0.683;
          this.boundingBox.bottomRight.y = 0.688;
          break;
        case 'PolicyLimitTwo':
          this.boundingBox.topLeft.x = 0.815;
          this.boundingBox.topLeft.y = 0.641;
          this.boundingBox.topRight.x = 0.942;
          this.boundingBox.topRight.y = 0.641;
          this.boundingBox.bottomLeft.x = 0.815;
          this.boundingBox.bottomLeft.y = 0.688;
          this.boundingBox.bottomRight.x = 0.942;
          this.boundingBox.bottomRight.y = 0.688;
          break;
        default:
          this.boundingBox.topLeft.x = 0.0565;
          this.boundingBox.topLeft.y = 0.232;
          this.boundingBox.topRight.x = 0.499;
          this.boundingBox.topRight.y = 0.232;
          this.boundingBox.bottomLeft.x = 0.0565;
          this.boundingBox.bottomLeft.y = 0.304;
          this.boundingBox.bottomRight.x = 0.499;
          this.boundingBox.bottomRight.y = 0.304;
          break;
      }
      this.setZoomDimensions();
    },
    setZoomDimensions() {
      var self = this;
      this.setPage1BoundingRect();
      this.boundingBoxDimensions.width =
        this.boundingBox.topRight.x - this.boundingBox.topLeft.x;
      this.boundingBoxDimensions.height =
        this.boundingBox.bottomLeft.y - this.boundingBox.topLeft.y;

      let scrollMarginX = this.scrollMargin.x;
      let scrollMarginY = this.scrollMargin.y;

      if (!this.controlClick) {
        if (
          this.scrollParams.offset.left + this.scrollParams.offset.buffer >
          this.boundingBox.topLeft.x * this.viewerDimensions.width
        ) {
          scrollMarginX = this.scrollMargin.default.x;
          // scrollMarginY = this.scrollMargin.default.y;
        } else if (
          this.scrollParams.offset.left + this.scrollParams.offset.buffer >
          (1 - this.boundingBox.topRight.x) * this.viewerDimensions.width
        ) {
          scrollMarginX = this.scrollMargin.default.x;
          // scrollMarginY = this.scrollMargin.default.y;
        }

        if (
          (this.boundingBoxDimensions.width + 2 * scrollMarginX) /
            this.viewerDimensions.width >
          (this.boundingBoxDimensions.height + 2 * scrollMarginY) /
            this.viewerDimensions.height
        ) {
          this.scale =
            1 / (this.boundingBoxDimensions.width + 2 * scrollMarginX);
          this.zoomBasedOn = 'x';
        } else {
          // just basing off width for now, may need to tweak going forward
          let scale =
            1 / (this.boundingBoxDimensions.height + 2 * scrollMarginY);
          if (scale >= this.scaleMax.y) {
            this.scale = this.scaleMax.y;
          } else {
            this.scale = scale;
          }

          this.defaultScale = scale;
          // this.zoomDimensions.scale = 1 / (this.boundingBoxDimensions.width + (2*scrollMarginX));
          this.zoomBasedOn = 'y';
        }

        setTimeout(function () {
          self.setPage1BoundingRect();
        }, 100);
      }
    },
    setScrollParams() {
      let scrollTop =
        this.boundingBox.topLeft.y * this.page1Dimensions.height -
        this.scrollParams.offset.top;
      if (scrollTop <= 0) {
        this.scrollParams.page1.top = 0;
      } else {
        this.scrollParams.page1.top = scrollTop;
      }

      let scrollLeft =
        this.boundingBox.topLeft.x * this.page1Dimensions.width -
        2 * this.scrollParams.offset.left;
      console.log('scrollLeft = ' + scrollLeft);
      if (scrollLeft <= this.scrollParams.offset.buffer) {
        this.scrollParams.page1.left = 0;
      } else {
        this.scrollParams.page1.left = scrollLeft;
      }

      console.log('topScroll = ' + this.scrollParams.page1.top);
      console.log('leftScroll = ' + this.scrollParams.page1.left);

      let viewer = document.getElementById('viewer');
      viewer.scrollTop = this.scrollParams.page1.top;
      viewer.scrollLeft = this.scrollParams.page1.left;

      // this.showBoundingBox = true;
    },
    setViewer() {
      let viewerElement = document.getElementById('viewer');
      this.viewer = viewerElement;
    },
    setViewerBoundingRect() {
      let viewer = document.getElementById('viewer');
      if (viewer) {
        this.viewerBoundingRect = viewer.getBoundingClientRect();
      }
    },
    setPage1BoundingRect() {
      let certificate_page1 = document.getElementById('certificate_page1');
      this.page1BoundingRect = certificate_page1?.getBoundingClientRect();
    },
    updateActivePage(value) {
      let newIndex = this.activeCertPageIndex + value;
      console.log('newIndex = ' + newIndex);
      if (this.testMultiplePages == true) {
        if (newIndex >= 0 && newIndex < this.testingMultipleCertPages.length) {
          console.log('updating page index');
          this.controlClick = true;
          this.activeCertPageIndex = newIndex;
          this.scaleFull();
        } else {
          // don't update index
          console.log('dont update page index');
        }
      } else {
        if (newIndex >= 0 && newIndex < this.certPages?.length) {
          console.log('updating page index');
          this.controlClick = true;
          this.activeCertPageIndex = newIndex;
          this.scaleFull();
        } else {
          // don't update index
          console.log('dont update page index');
        }
      }
    },
  },

  // "$store.state.form.checkoutCertificate": {
  //   deep: true,
  //   handler: function(newVal) {
  //     this.certData = newVal;
  //   },
  //   immediate: true
  // }
};
</script>
<style scoped>
.pdf-backdrop-color {
  background: #535659;
}
.cls-bb1-1 {
  opacity: 0.4;
}
.cls-bb1-2 {
  fill: #c7cada;
}
.cls-bb1-3 {
  fill: none;
  stroke: #c7cada;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-width: 2px;
  opacity: 0;
}
.cls-bb2-1 {
  fill: none;
  stroke: #c7cada;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-width: 2px;
}
.cls-bb2-1,
.cls-bb2-2 {
  opacity: 0.5;
}
.cls-bb2-3,
.cls-bb2-4 {
  fill: #c7cada;
}
.cls-bb2-3 {
  opacity: 0.4;
}
</style>
